






































































import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "@/plugins/axios";
import { Event } from "@/types";

@Component
export default class EventActions extends Vue {
  @Prop() event!: Event;
  dialog = false;

  get roomcode() {
    return this.event.roomcode;
  }

  set roomcode(code) {
    this.event.roomcode = code;
  }

  get attending() {
    if (this.event.attending !== undefined) {
      return this.event.attending;
    }
    return -1;
  }

  set attending(state) {
    if (!isNaN(state)) {
      this.$store.dispatch("setAttending", { event: this.event, state });
    }
  }

  decisionColor(attendee: { attending: number | undefined }) {
    switch (attendee.attending) {
      case 1:
        return "success";
      case 2:
        return "warning";
      default:
        return "red";
    }
  }

  get form() {
    return (this.$refs.form as unknown) as {
      reset(): void;
      resetValidation(): void;
      validate(): boolean;
    };
  }

  close() {
    this.dialog = false;
    this.form.resetValidation();
  }

  save() {
    this.form.validate();
    axios
      .post("/api/schedule/streaming", {
        event: this.event.id,
        code: this.roomcode
      })
      .then(() => {
        this.dialog = false;
      });
  }
}
